import * as constants from "../store/Constants";
import { Recipe } from "../store/Recipe";

export enum SortType {
  DEFAULT, // Original list order (reversed).
  ALPHABETICAL,
  TIME, // Time to cook.
  DATE // Entry date. All recipes without entry date fallback to default.
}

export const sortRecipeByName = (recipe1: Recipe, recipe2: Recipe) => {
  const name1 = recipe1[constants.Name].toLowerCase();
  const name2 = recipe2[constants.Name].toLowerCase();

  if (name1 < name2) {
    return -1;
  } else if (name1 > name2) {
    return 1;
  }
  return 0;
};

export const sortRecipeByTime = (recipe1: Recipe, recipe2: Recipe) => {
  const time1 = parseFloat(recipe1[constants.Time]);
  const time2 = parseFloat(recipe2[constants.Time]);

  if (time1 < time2) {
    return -1;
  } else if (time1 > time2) {
    return 1;
  }
  return 0;
};

export const sortRecipeByDate = (recipe1: Recipe, recipe2: Recipe) => {
  const date1 = new Date(recipe1[constants.EntryDate]);
  const date2 = new Date(recipe2[constants.EntryDate]);

  if (date1 < date2) {
    return -1;
  } else if (date1 > date2) {
    return 1;
  }
  return 0;
};
